import {Injectable, inject} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiService} from '../base/api.service';
import {FileUrlItemResponse} from './entities/file-url-item-response';
import {ItemCreatedResponse} from '../../entities/base/item-created-response';
import {GeneratedHistoryReportStatus, GeneratedHistoryReportStatusResponse} from './entities/history-report-status-response';
import {Upload} from '../upload-repository/entities/upload';
import {HistoryReportItemResponse} from './entities/history-report-item-response';
import {HistoryReportCollectionResponse} from './entities/history-report-collection-response';
import {SignedUrlResponse} from '../../entities/base/signed-url-response';

@Injectable({
  providedIn: 'root'
})
export class FilesRepositoryService {

  private api = inject(ApiService);

  getUrl(fileType: string, fileId: number, patientId: number, practitionerId?: number): Observable<string> {
    return this.api.get<FileUrlItemResponse>('documents/generate-url', {fileType, fileId, patientId, practitionerId})
      .pipe(map(response => this.api.url + response.value));
  }

  getSignedReportsUrl(file: string, action: string, expires: number): Observable<string> {
    return this.api.get<SignedUrlResponse>('uploads/practice-history-reports/generate-signed-url', {fileName: file, action: action, expires: expires})
      .pipe(map(response => response.value));
  }

  enqueueGeneratedReport(patientId: number, options?: { fromDate?: Date; toDate?: Date; practitionerId?: number }): Observable<number> {
    return this.api.post<ItemCreatedResponse>('documents/generate-history/enqueue', {patientId, ...options})
      .pipe(map(response => response.value));
  }

  getEnqueuedGeneratedReportStatus(id: number): Observable<GeneratedHistoryReportStatus> {
    return this.api.get<GeneratedHistoryReportStatusResponse>('documents/generate-history/status/' + id)
      .pipe(map(response => response.value));
  }

  getEnqueuedGeneratedReport(id: number): Observable<Upload> {
    return this.api.get<HistoryReportItemResponse>('documents/generate-history/' + id)
      .pipe(map(response => response.value));
  }
  getEnqueuedGeneratedReports(patientId: number): Observable<Upload[]> {
    return this.api.get<HistoryReportCollectionResponse>('documents/generate-history/reports/' + patientId)
      .pipe(map(response => response.items));
  }


}
